var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77778 2.22222C2.77778 1.63285 3.0119 1.06762 3.42865 0.650874C3.8454 0.234126 4.41063 0 5 0C5.58937 0 6.1546 0.234126 6.57135 0.650874C6.9881 1.06762 7.22222 1.63285 7.22222 2.22222C7.22222 2.81159 6.9881 3.37682 6.57135 3.79357C6.1546 4.21032 5.58937 4.44444 5 4.44444C4.41063 4.44444 3.8454 4.21032 3.42865 3.79357C3.0119 3.37682 2.77778 2.81159 2.77778 2.22222ZM2.77778 5.55556C2.04107 5.55556 1.33453 5.84821 0.813592 6.36915C0.292658 6.89008 0 7.59662 0 8.33333C0 8.77536 0.175595 9.19928 0.488155 9.51185C0.800716 9.82441 1.22464 10 1.66667 10H8.33333C8.77536 10 9.19928 9.82441 9.51185 9.51185C9.82441 9.19928 10 8.77536 10 8.33333C10 7.59662 9.70734 6.89008 9.18641 6.36915C8.66547 5.84821 7.95894 5.55556 7.22222 5.55556H2.77778Z",
    fill: "#010048",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.4e4f80083c0ff2e3f11a993ef9fb3012.svg";
export { ForwardRef as ReactComponent };